import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import _ from "lodash"
import produce from "immer"

import { v4 as uuid } from "uuid"
import { JsonErrorCode } from "../api/Communication"

export enum NotificationKind {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  SUCCESS = "success"
}

export interface INotification {
  id?: string
  kind: NotificationKind
  title: string
  message: string
  code?: number
}

export interface IState {
  notifications: INotification[]
}
const notificationSlice = createSlice({
  name: "notifications",

  initialState: {
    notifications: []
  },

  reducers: {
    notify: produce((draft: IState, action: PayloadAction<INotification>) => {
      if (draft.notifications == null) {
        draft.notifications = []
      }

      const guid = uuid()

      draft.notifications.unshift({
        id: guid,
        kind: action.payload.kind,
        title: action.payload.title,
        message: action.payload.message,
        code: action.payload.code
      })
    }),

    closeNotification: produce(
      (draft: IState, action: PayloadAction<string>) => {
        let notifications = draft.notifications
        notifications = _.filter(notifications, (n) => {
          return n.id !== action.payload
        })
        draft.notifications = notifications
      }
    ),

    closeAlmostAllNotifications: produce((draft: IState) => {
      let notifications = draft.notifications
      notifications = _.filter(notifications, (n) => {
        return (
          n.code === JsonErrorCode.AuthenticationError ||
          n.code === JsonErrorCode.AuthorizationError
        )
      })
      draft.notifications = notifications
    }),
    closeAllNotifications: produce((draft: IState) => {
      draft.notifications = []
    })
  }
})

export const {
  notify,
  closeNotification,
  closeAlmostAllNotifications,
  closeAllNotifications
} = notificationSlice.actions

export default notificationSlice.reducer
